import { atom } from 'jotai'

import { type DetailInfo } from '@/features/vehicle-dispatch-boards/formatters'

/**
 * 配車板の配送依頼詳細Modalで表示する配送明細情報
 * - この中の値を利用して、詳細を取得する
 */
export const vehicleDispatchBoardsDispatchDetailAtom = atom<DetailInfo | null>(
  null
)

vehicleDispatchBoardsDispatchDetailAtom.debugLabel =
  'vehicleDispatchBoardsDispatchDetailAtom'
